import { useRef, useEffect } from 'react';

function useDocumentEvent(eventname, func, options) {
  const enabled = options?.enabled ?? true;
  const onUnmountRef = useRef(options?.onUnmount);
  onUnmountRef.current = options?.onUnmount;
  const funcRef = useRef(func);
  funcRef.current = func;
  useEffect(() => {
    if (enabled) {
      const onEvent = (e) => {
        funcRef.current(e);
      };
      document.addEventListener(eventname, onEvent);
      return () => {
        document.removeEventListener(eventname, onEvent);
        onUnmountRef.current?.();
      };
    }
  }, [
    enabled,
    eventname
  ]);
}

export { useDocumentEvent };
//# sourceMappingURL=useDocumentEvent.js.map
